import React, { useEffect } from 'react'
import PageCard from '../../common/PageCard'
import Page from '../../common/Page'
import $t from '../../../i18n'
import { useDispatch, useSelector } from 'react-redux'
import { Avatar, Button } from 'antd'
import Actions from '../../../actions'
import config from '../../../config.json'
import Card from '../../common/Card'
import dayjs from 'dayjs'
import { routes } from '../../../consts'
import { event, eventTypes } from '../../../consts/eventConsts'
import { isMemberInsuranceBeforePayment } from '../../../utils/hmoUtils'
import { getLatestEnrollmentYear } from '../../../utils/paymentUtils'
import './IdCards.css'

const IdCards = () => {
  const dispatch = useDispatch()

  const { isUserDetailsLoading, userDetails } = useSelector(
    state => state.profile
  )
  const { selectedMember, activeMembers } = useSelector(state => state.account)

  const { isRenewingEnrollment, enrollmentYears } = useSelector(
    state => state.payment
  )

  const nirvanaSupportPhone = useSelector(
    state => state.app?.nirvanaSupportPhone
  )

  const { firstName, lastName, dateOfBirth, id } = userDetails || {}

  const activeMembersWithInsuredOnly = activeMembers.filter(
    member => member?.hmo_member_id
  )

  const isNoOtherInsuredMembers = !activeMembersWithInsuredOnly?.length

  const activeMembersWithOwnerOption = [
    { firstName, lastName, dateOfBirth, id }
  ].concat(activeMembersWithInsuredOnly)

  const displayMembers = selectedMember?.id
    ? activeMembersWithOwnerOption?.filter(
        member => member?.id.toString() === selectedMember?.id.toString()
      )
    : activeMembersWithOwnerOption

  // if the user is an hmo member and the insurance is not activated
  const isInsuranceBeforePayment = isMemberInsuranceBeforePayment(userDetails)

  useEffect(() => {
    // if the selected member is not insured, we need to select family view
    if (!selectedMember?.hmo_member_id) {
      dispatch(
        Actions.createAction(Actions.CHOOSE_FAMILY_MEMBER, {
          member: null
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const navigateToCardView = memberId => {
    dispatch(
      Actions.createAction(
        Actions.NAVIGATED_TO,
        routes.PROFILE_ROUTE.ID_CARD_FILE_VIEW.replace(':id', memberId)
      )
    )
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        type: eventTypes.click,
        eventName: event.clickEvent.click,
        element: 'Id Card - ' + memberId
      })
    )
  }

  const navigateToPayment = () => {
    dispatch(
      Actions.createAction(Actions.NAVIGATED_TO, routes.MENU_ROUTE.PAYMENTS)
    )
  }

  return (
    <PageCard className='id-cards-page-card' enableBack={true}>
      <Page
        loading={isUserDetailsLoading}
        className='id-cards-page'
        title={
          isNoOtherInsuredMembers
            ? $t('pages.idCards.idCard')
            : $t('pages.idCards.title')
        }
        subtitle={
          isInsuranceBeforePayment
            ? ''
            : $t('pages.idCards.subtitle', { phone: nirvanaSupportPhone })
        }
        hideAlertBanner={true}
        displayManageFamily={!isNoOtherInsuredMembers}
        manageFamilyProps={{
          isNotEnsuredDisabled: true
        }}
      >
        {isRenewingEnrollment && (
          <div className='id-cards-renewal-banner'>
            <i className='icon icon-clock' />
            <div>
              {$t('pages.idCards.renewalTitle', {
                latestYear: getLatestEnrollmentYear(enrollmentYears)
              })}
            </div>
          </div>
        )}
        {!isInsuranceBeforePayment &&
          displayMembers?.map(member => (
            <Card
              key={member?.id}
              className='id-card-card'
              onClick={() => navigateToCardView(member?.id)}
            >
              <Avatar
                className='member-avatar'
                size='large'
                style={{ backgroundColor: member?.color || 'var(--success)' }}
              >
                {member?.firstName?.toUpperCase()?.slice(0, 1) +
                  member?.lastName?.toUpperCase()?.slice(0, 1)}
              </Avatar>
              <div className='member-details'>
                <div className='member-name'>
                  {member?.firstName} {member?.lastName}
                </div>
                <div className='member-bithdate'>
                  {$t('pages.idCards.birthDate')}{' '}
                  {dayjs(member?.dateOfBirth)?.format(config.genericDateFormat)}
                </div>
              </div>
              <span className='icon-arrow-bold-right icon-arrow' />
            </Card>
          ))}

        {isInsuranceBeforePayment && (
          <div className='id-card-before-payment'>
            <img
              className='card-empty-image'
              src={config.gcpStorageUrl + '/img/idCard-empty.svg'}
              alt=''
              onClick={navigateToPayment}
            />
            <div className='id-card-before-payment-title semi-bold'>
              {$t('pages.idCards.beforePaymentTitle')}
            </div>
            <div className='id-card-before-payment-subtitle'>
              {$t('pages.idCards.beforePaymentSubtitle')}
            </div>
            <Button
              type='primary'
              className='trackable'
              data-name='proceed-payment'
              onClick={navigateToPayment}
            >
              {$t('pages.idCards.proceedToPayment')}
            </Button>
          </div>
        )}
      </Page>
    </PageCard>
  )
}

export default IdCards
